import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import CompleteProjectModal from './completeProjectModal';
import { getModal } from '../../../../../state/ui/selectors';
import { projectsActions, projectsSelectors } from '../../../../../state/projects';
import { uiActions } from '../../../../../state/ui';
import { STATUS } from '../../../../../constants/projects';

const mapStateToProps = (state, { selectedProjectId }) => ({
  isOpen: getModal(state)('completeProjectModal'),
  project: projectsSelectors.getProject(state)(selectedProjectId),
});

const mapDispatchToProps = ({
  onCloseModal: () => uiActions.closeModal('completeProjectModal'),
  editProject: projectsActions.editProjectRequest,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onComplete: ({
      editProject,
      selectedProjectId, onCloseModal, project,
    }) => () => editProject({ id: selectedProjectId, ...project, status: STATUS.COMPLETED }, {
      callbacks: {
        success: onCloseModal,
      },
    }),
  }),
);

export default enhance(CompleteProjectModal);
